import React from 'react'
import styled from 'styled-components'
import PropTypes from 'prop-types'

import FullCalendar from '@fullcalendar/react'
import dayGridPlugin from '@fullcalendar/daygrid'
import { color, fontSize, spacing, breakpoint } from '../theme'
import { CalendarEvent } from '../molecules/CalendarEvent'

/* This should return a event - component */
const renderEventContent = eventInfo => {
   return (
      <div>
         {eventInfo.event.extendedProps.schedules.map((student, key) => (
            <CalendarEvent
               name={student.name}
               dropOff={student.dropOff}
               pickUp={student.pickUp}
               childOrder={student.childOrder}
               key={key}
            />
         ))}
      </div>
   )
}

/* Override Calendar styling  */
const CalendarWrapper = styled.div`
   z-index: 0;
   position: relative;

   /* Toolbar */
   .fc-toolbar.fc-header-toolbar {
      margin-bottom: ${spacing.m};
      h2 {
         font-size: ${fontSize.xl};
      }
      .fc-button {
         font-size: ${fontSize.sm};
      }
      @media screen and (max-width: ${breakpoint.s}) {
         .fc-toolbar-chunk:last-child {
            display: flex;
            flex-direction: column;
            .fc-today-button {
               margin-bottom: ${spacing.s};
            }
            .fc-button-group {
               margin-left: 0;
            }
         }
      }
   }

   /* Background on calendar */
   .fc-daygrid {
      background: ${color.white};
   }

   /* Calendar Header*/
   .fc-col-header {
      background: ${color.primary};
      color: ${color.white};

      th {
         font-weight: 500;
      }
   }

   /* Day-header */
   .fc-daygrid-day-top {
      font-size: ${fontSize.s};
   }

   /* Week number */
   .fc-daygrid-week-number {
      font-size: ${fontSize.s};
      font-weight: bold;
      color: ${color.text};
   }

   /* Today */
   .fc-daygrid-day.fc-day-today {
      background-color: ${color.borderLight};
      .fc-daygrid-day-top {
         font-weight: bold;
      }
   }

   /* Remove default styling from events */
   .fc-daygrid-event {
      border-radius: 0;
   }
`

export const Calendar = ({ eventData, onEventClick, startDate }) => {
   const events = eventData
      ? eventData.map(event => ({
           title: 'Fritid bookings',
           date: event.date,
           extendedProps: { date: event.date, schedules: event.schedules }
        }))
      : null

   return (
      <CalendarWrapper>
         <FullCalendar
            plugins={[dayGridPlugin]}
            initialView="dayGridMonth"
            weekends={false}
            initialDate={startDate ? startDate : new Date()}
            events={events}
            eventContent={renderEventContent}
            weekNumbers={true}
            eventBackgroundColor={'transparent'}
            eventBorderColor={'transparent'}
            eventClick={info => {
               onEventClick && onEventClick(info.event.extendedProps)
            }}
         />
      </CalendarWrapper>
   )
}

Calendar.propTypes = {
   /**
    * All booked and avaliable dates
    */
   eventData: PropTypes.array.isRequired,
   /**
    * Event when clicked event
    */
   onEventClick: PropTypes.func,
   /**
    *  initial Calendar date
    */
   startDate: PropTypes.string
}

Calendar.defaultProps = {
   eventData: [],
   onEventClick: undefined,
   startDate: ''
}
